/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Rating, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Testimonio = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{pt: 4}}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#fff',
                    borderRadius: 10,
                    boxShadow: 4,
                    m: 4,
                    p: 4

                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -10}}>
                    <Avatar src={item.img} sx={{width: sCell ? 80 : 100, height: sCell ? 80 : 100}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{
                        fontFamily: NEGRITA,
                        fontSize: sCell ? 32 : 48,
                        fontWeight: 600,
                        textAlign: 'center',
                        color: theme.palette.primary.main,
                        lineHeight: 1.2
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography
                        sx={{fontSize: sCell ? 16 : 18, fontWeight: 600, textAlign: 'center'}}>{item.tipo}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{
                        fontSize: sCell ? 14 : 16,
                        fontWeight: 400,
                        textAlign: 'center'
                    }}>{item.testimonio}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Rating size={'large'} value={5}/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Testimonio